<template>
  <section id="relic-detail-repair">
    <edit-header
      title="修缮记录"
      :visible-action="false"
      :visible-add="true"
      add-text="添加修缮记录"
      @onAddClick="handleAddReport"
      :addLimit="limitRepairAdd"
    ></edit-header>
    <img
      v-if="limitShow || limitRepairAdd"
      class="report-delete"
      :src="deleteList[0] ? deletePic.normal_delete : deletePic.disabled_delete"
      alt="删除"
      @click="handleDeleteClick"
    />
    <table-vue
      :columns="columns"
      :tableData="repairList"
      @onSelectItem="handleDeleteRecords"
      @onRowClick="handleEditClick"
    />
    <div class="font-label report-tip">
      显示最新十条巡查记录，更多可前往
      <router-link class="report-tip-link" :to="{ name: 'RepairList' }">
        【修缮记录】
      </router-link>
      进行查看
    </div>
    <repair-create
      v-model="saveCtrlParam"
      v-bind:repairRecord.sync="repairRecord"
      @onSaveAllClick="handleSaveAllClick"
      @onCancelEdit="initRepairRecord"
      @onSavePart="updateRepairRecord"
    />
    <confirm-delete-popup
      v-if="visiblePopup"
      @onConfirmDelete="handleConfirmDelete"
      @onCancelDelete="visiblePopup = false"
    />
    <file-uploader-ctrl ref="uploader" :filePath="filePath" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  AddRepairRecord,
  GetSingleRepairRecord,
  UpdateRepairData
} from '../../api';
import { roleJudge } from '../../config/roleJudge';
import ConfirmDeletePopup from '../layout/confirm-delete-popup.vue';
import editHeader from '../layout/edit-header.vue';
import FileUploaderCtrl from '../layout/file-uploader-ctrl.vue';
import tableVue from '../layout/table.vue';
import RepairCreate from '../repair/repair-create.vue';
import { repairDataList } from '../repair/repair-list';
// import Table from '../layout/table.vue';
export default {
  components: {
    editHeader,
    tableVue,
    RepairCreate,
    FileUploaderCtrl,
    ConfirmDeletePopup
  },
  props: {
    repairList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      repairRecordUid: '',
      visiblePopup: false,
      deleteList: [],
      repairData: [],
      columns: repairDataList,
      visibleCreateDialog: false,
      repairRecord: {},
      deletePic: {
        normal_delete: require('../../assets/images/normal_delete.svg'),
        disabled_delete: require('../../assets/images/disabled_delete.svg')
      },
      saveCtrlParam: {
        visibleAddDialog: false, //是否显示弹窗
        active: 0, //控制组件活动
        visibleEdit: false, //是否可编辑
        visibleCreate: false //是否是创建模式
      }
    };
  },
  computed: {
    ...mapState('relic', ['relicDetail']),
    ...mapState('login', ['userInfo', 'authorizationLimit', 'limitShow']),
    rerlicId() {
      return this.$route.params.id;
    },
    limitRepairAdd() {
      return roleJudge(this.authorizationLimit, 1, 2, 3, 4);
    },
    filePath() {
      return `relic/${this.relicDetail.relicAutoIncrementId}/repair`;
    }
  },
  watch: {
    saveCtrlParam: {
      deep: true,
      handler(newValue) {
        if (!newValue.visibleAddDialog) {
          this.$emit('onRefreshRepairList');
        }
      }
    }
  },
  methods: {
    handleDeleteClick() {
      if (this.deleteList.length > 0) {
        this.visiblePopup = true;
      }
    },
    /**
     * 删除修缮记录
     */
    handleDeleteRecords(itemList) {
      this.deleteList = itemList;
    },

    /**
     * 确认删除
     */
    handleConfirmDelete() {
      this.visiblePopup = false;
      this.$emit('onDeleteRepair', this.deleteList);
    },
    /**
     * 创建打开弹窗
     */
    handleAddReport() {
      this.saveCtrlParam.visibleAddDialog = true;
      this.saveCtrlParam.visibleCreate = true;
      this.saveCtrlParam.visibleEdit = true;
      this.repairRecord = {
        acceptanceDate: '',
        completionDate: '',
        constructionUnit: '',
        constructionUnitContact: '',
        fileList: [],
        investigationReport: [],
        designScheme: [],
        constructionScheme: [],
        completionReport: [],
        approvalDocument: [],
        ownerUnit: '',
        ownerUnitContact: '',
        photoList: [],
        afterPhoto: [],
        beforePhoto: [],
        relicFromUserId: this.relicDetail.relicFromUserId,
        relicName: this.relicDetail.relicName,
        remark: '',
        recordFromUserId: ''
      };
    },

    /**
     * 保存监听
     */
    async handleSaveAllClick() {
      this.saveCtrlParam.visibleCreate
        ? await this.createRepairSuccess()
        : await this.updateRepairRecord();
      this.saveCtrlParam.visibleAddDialog = false;
    },

    /**
     * 创建修缮记录
     */
    async createRepairSuccess() {
      const {
        approvalDocument,
        completionReport,
        constructionScheme,
        designScheme,
        investigationReport,
        beforePhoto,
        afterPhoto
      } = this.repairRecord;
      const fileArr = [
        ...approvalDocument,
        ...completionReport,
        ...constructionScheme,
        ...designScheme,
        ...investigationReport
      ];
      const photoArr = [...beforePhoto, ...afterPhoto];
      const photoList = await this.initUploadPhoto(photoArr);
      const fileList = await this.initUploadFile(fileArr);
      const repairData = Object.assign({}, this.repairRecord, {
        photoList,
        fileList,
        approvalDocument: null,
        completionReport: null,
        constructionScheme: null,
        designScheme: null,
        investigationReport: null,
        beforePhoto: null,
        afterPhoto: null,
        relicAutoIncrementId: this.rerlicId
      });
      await AddRepairRecord(repairData);
      this.saveCtrlParam.visibleAddDialog = false;
      this.saveCtrlParam.active = 0;
      this.$prompt('创建成功');
    },

    /**
     * 初始化上传照片
     * @param {Array} params 照片数组
     */
    async initUploadPhoto(params) {
      let oldArray = params.filter(item => !item.file);
      let newArray = params.filter(item => item.file);
      if (newArray.length > 0) {
        const result = await this.$refs.uploader.uploadFileParams(newArray);
        newArray = result.map(item => {
          const {
            value: { param, url }
          } = item;
          delete param.file;
          delete param.photoUid;
          param.photoUrl = url;
          return param;
        });
      }
      return [...oldArray, ...newArray];
    },

    /**
     * 初始化上传文件
     * @param {Array} params 文件数组
     */
    async initUploadFile(params) {
      let oldArray = params.filter(item => !item.file);
      let newArray = params.filter(item => item.file);
      if (newArray.length > 0) {
        const result = await this.$refs.uploader.uploadFileParams(newArray);
        newArray = result.map(item => {
          const {
            value: { param, url }
          } = item;
          delete param.file;
          delete param.fileUid;
          param.fileUrl = url;
          return param;
        });
      }
      return [...oldArray, ...newArray];
    },
    /**
     * 点击获取单个修缮记录报告
     */
    async handleEditClick(row) {
      const { repairRecordUid } = row;
      this.repairRecordUid = repairRecordUid;
      await this.initRepairRecord(repairRecordUid);
      this.saveCtrlParam.visibleEdit = false;
      this.saveCtrlParam.active = 0;
      this.saveCtrlParam.visibleCreate = false;
      this.saveCtrlParam.visibleAddDialog = true;
    },
    /**
     * 初始化单个修缮数据
     */
    async initRepairRecord(id = this.repairRecordUid) {
      const {
        data: { data }
      } = await GetSingleRepairRecord(id);
      const { photoList, fileList } = data;
      const approvalDocument = this.initArray(fileList, 'APPROVAL_DOCUMENT');
      const completionReport = this.initArray(fileList, 'COMPLETION_REPORT');
      const constructionScheme = this.initArray(
        fileList,
        'CONSTRUCTION_SCHEME'
      );
      const designScheme = this.initArray(fileList, 'DESIGN_SCHEME');
      const investigationReport = this.initArray(
        fileList,
        'INVESTIGATION_REPORT'
      );
      const beforePhoto = this.initArray(photoList, 'PHOTO_BEFORE_REPAIR');
      const afterPhoto = this.initArray(photoList, 'PHOTO_AFTER_COMPLETION');
      this.repairRecord = Object.assign({}, data, {
        approvalDocument,
        completionReport,
        constructionScheme,
        designScheme,
        investigationReport,
        beforePhoto,
        afterPhoto,
        repairRecordUid: id
      });
    },
    /**
     * 初始化数组
     * @param {Array} params
     */
    initArray(params, type) {
      return params.filter(
        item => item.fileTypeEnum == type || item.photoTypeEnum == type
      );
    },

    /**
     * 更新修缮记录
     */
    async updateRepairRecord() {
      const params = Object.assign({}, this.repairRecord);
      const {
        approvalDocument,
        completionReport,
        constructionScheme,
        designScheme,
        investigationReport,
        beforePhoto,
        afterPhoto
      } = params;
      const fileArr = [
        ...approvalDocument,
        ...completionReport,
        ...constructionScheme,
        ...designScheme,
        ...investigationReport
      ];
      const photoArr = [...beforePhoto, ...afterPhoto];
      const photoList = await this.initUploadPhoto(photoArr);
      const fileList = await this.initUploadFile(fileArr);
      const repairData = Object.assign({}, params, {
        photoList,
        fileList,
        approvalDocument: null,
        completionReport: null,
        constructionScheme: null,
        designScheme: null,
        investigationReport: null,
        beforePhoto: null,
        afterPhoto: null,
        relicAutoIncrementId: this.rerlicId
      });
      await UpdateRepairData(repairData);
      await this.initRepairRecord(this.repairRecordUid);
      this.$prompt('修改成功');
    }
  }
};
</script>

<style lang="scss">
#relic-detail-repair {
  padding-bottom: 20px;
  .report {
    &-delete {
      margin-top: 10px;
      margin-left: 20px;
    }
    &-tip {
      padding: 10px 0px;
      &-link {
        color: $color-primary;
      }
    }
  }
}
</style>
